import React, { useState } from 'react'
import { Box, Tab, Typography } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { useTranslation } from 'react-i18next'
import All from './all'
import Unread from './Unread'
import styles from './Notifications.module.scss'

interface NotificationsProps {
  isHeader?: boolean
}

export const Notifications = ({ isHeader }: NotificationsProps) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('1')

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  return (
    <Box className={`${styles.notificationsContainer} ${isHeader ? styles.isHeader : ''}`}>
      {/* Header Title - only for popover */}
      {isHeader && (
        <Box className={styles.header}>
          <Typography className={styles.headerTitle}>
            {t('notifications')}
          </Typography>
        </Box>
      )}

      <TabContext value={value}>
        <Box className={`${styles.tabsContainer} ${isHeader ? styles.isHeader : ''}`}>
          <TabList 
            onChange={handleChange} 
            aria-label="notifications tabs"
            className={styles.tabList}
            TabIndicatorProps={{
              className: styles.tabIndicator
            }}
          >
            <Tab 
              label={t('all')} 
              value="1" 
              className={`${styles.tab} ${isHeader ? styles.isHeader : ''}`}
            />
            <Tab 
              label={t('unread')} 
              value="2" 
              className={`${styles.tab} ${isHeader ? styles.isHeader : ''}`}
            />
          </TabList>
        </Box>

        <TabPanel 
          value="1" 
          className={`${styles.tabPanel} ${isHeader ? styles.isHeader : ''}`}
        >
          <All isHeader={isHeader} />
        </TabPanel>

        <TabPanel 
          value="2" 
          className={`${styles.tabPanel} ${isHeader ? styles.isHeader : ''}`}
        >
          <Unread isHeader={isHeader} />
        </TabPanel>
      </TabContext>
    </Box>
  )
}

export default Notifications